import { render, staticRenderFns } from "./Controlcenter.vue?vue&type=template&id=3b9db174&scoped=true"
import script from "./Controlcenter.vue?vue&type=script&lang=js"
export * from "./Controlcenter.vue?vue&type=script&lang=js"
import style0 from "./Controlcenter.vue?vue&type=style&index=0&id=3b9db174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9db174",
  null
  
)

export default component.exports